import { GsFormSchema } from '../../../components';
import { CONTACT_FORM_COMPONENT_FORM_SCHEMA } from './contact-form.component.schema';

/**
 * Form schema for the OrderRevocationForm component settings in the designer.
 * Reuses the ContactForm schema, since the component reuses the ContactForm rendering pipeline.
 */
export const ORDER_REVOCATION_FORM_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [...(CONTACT_FORM_COMPONENT_FORM_SCHEMA.fields ?? [])]
};
